import {URL_BASE} from "../../../Globals.ts";
import {v4 as uuidv4} from "uuid";
import {addNewChatToHistory} from "./chatMetadataUtils.ts";
import {MessageNode} from "../../messageObject/MessageNode.ts";
import {getIdToken} from "../../misc/miscUtils.ts";

export const writeFullChat = async (user: any, conversationId: string, messagesSequenceRef: any, newMessages: any[]) => {
    if (!user) return;
    const token = await getIdToken(user);
    const messagesSequence = messagesSequenceRef.current;

    const url = `${URL_BASE}/api/writeFullChat`;
    await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
            conversationId: conversationId,
            newMessages: newMessages,
            messagesSequence: messagesSequence
        })
    });
}

export const initializeNewChat = async (userText: string, isIncognito: boolean, user: any, setDynamicStateObj: any, updateChatHistory: any, setMessages: any, messagesRef: any, currentMessageRef: any, conversationId: string | null = null) => {
    const rootNode = new MessageNode(uuidv4());
    setMessages(rootNode);
    messagesRef.current = rootNode;
    currentMessageRef.current = rootNode;

    conversationId = conversationId ?? uuidv4();
    setDynamicStateObj({conversationId: conversationId});

    await addNewChatToHistory(userText, isIncognito, updateChatHistory, conversationId, user);
};
